import { makeObservable, observable, computed } from 'mobx';
import SubscriberBasicInfoDelegate from 'store/modules/subscriber/subscriber-basic-info/subscriberBasicInfoDelegate';
import SubDependentDelegate from 'store/modules/subscriber/subscriber-basic-info/dependents/subDependentDelegate';

export interface IDependentsTabPageStore {
  readonly isInitialDataLoading: boolean;
  readonly subscriberBasicInfo: SubscriberBasicInfoDelegate | undefined;
}

export default class DependentsTab {
  private _pageStore: IDependentsTabPageStore;
  private _getDependentFormId: () => string | undefined;

  public getDependentFormId(): string | undefined {
    return this._getDependentFormId();
  }

  public get subscriberBasicInfo(): SubscriberBasicInfoDelegate | undefined {
    return this._pageStore.subscriberBasicInfo;
  }

  public get dependentDelegates(): SubDependentDelegate[] {
    return this.subscriberBasicInfo?.subscriberDependentsDelegates || [];
  }

  public get isLoading(): boolean {
    return this._pageStore.isInitialDataLoading;
  }

  constructor(pageStore: IDependentsTabPageStore, getDependentFormId: () => string | undefined) {
    this._pageStore = pageStore;
    this._getDependentFormId = getDependentFormId;

    makeObservable<DependentsTab, '_pageStore' | '_getDependentFormId'>(this, {
      _pageStore: observable,
      _getDependentFormId: observable,
      subscriberBasicInfo: computed,
      dependentDelegates: computed,
      isLoading: computed,
    });
  }
}
